import { CheckIcon } from '@approvalmax/ui';
import { Box, Divider, Flex, Grid, Text } from '@approvalmax/ui/src/components';
import { hooks } from '@approvalmax/utils';
import { memo, useCallback } from 'react';
import { convertBillingAddressToString } from 'shared/helpers';

import { activeContactIdQueryParam } from '../../../../constants';
import { messages } from './Item.messages';
import { ItemProps } from './Item.types';

export const Item = memo<ItemProps>((props) => {
    const { contactId, contactName, billingAddress, hasDetails, active } = props;

    const setActiveContactId = hooks.useQueryParam(activeContactIdQueryParam)[1];

    const handleItemClick = useCallback(() => {
        setActiveContactId(contactId);
    }, [setActiveContactId, contactId]);

    const billingAddressString = billingAddress ? convertBillingAddressToString(billingAddress, ', ') : '';

    return (
        <Box
            color={active ? 'silver80' : undefined}
            spacing='12 24 0 60'
            role='listitem'
            tabIndex={0}
            onClick={handleItemClick}
        >
            <Grid inline alignItems='center' gridTemplateColumns='auto max-content' columnGap={8} width='100%'>
                <Text ellipsis={1} font='body' fontSize='medium' fontWeight='medium' title={contactName}>
                    {contactName}
                </Text>

                {hasDetails && (
                    <Box bordered borderColor='green100' spacing='4 8'>
                        <Flex alignItems='center' spacing='2'>
                            <CheckIcon color='green100' size={12} />

                            <Text color='green100' ellipsis={1} font='label' fontSize='xsmall' fontWeight='regular'>
                                {messages.hasDetails}
                            </Text>
                        </Flex>
                    </Box>
                )}
            </Grid>

            {billingAddressString && (
                <Box spacing='4 0 0 0'>
                    <Text
                        color='midnight70'
                        ellipsis={1}
                        font='label'
                        fontSize='small'
                        fontWeight='regular'
                        title={billingAddressString}
                    >
                        {billingAddressString}
                    </Text>
                </Box>
            )}

            <Divider color='silver80' spacing='12 0 0 0' />
        </Box>
    );
});

Item.displayName = 'Item';
